import GamePlayPage from "./index";
import {LoginAwareWrapper} from "../../../common/component/LoginAwareWrapper";

export default function GamePlayPageContainer() {
    return (
        <LoginAwareWrapper>
            <GamePlayPage/>
        </LoginAwareWrapper>
    )
}